import { useAuthService } from '@vivli/core/infrastructure/hook';
import { IContextWrapper } from '@vivli/shared/infrastructure/interface';
import { AuthContext } from '@vivli/core/infrastructure/context';
import { IAuthContext } from '@vivli/core/infrastructure/interface';

export const PlatformAuthContextWrapper = ({ children }: IContextWrapper) => {
    const authService = useAuthService('test');

    const provider: IAuthContext = {
        authService
    };

    return <AuthContext.Provider value={provider}>{children}</AuthContext.Provider>;
};
